import { useTranslation } from 'react-i18next'
import PartnerCard from './PartnerCard'

const PartnerList = ({ partners, loading, error, onPartnerClick }) => {
  const { t } = useTranslation()
  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        <span className="ml-3 text-gray-600">{t('partners.states.loading')}</span>
      </div>
    )
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <div className="text-red-500 mb-4">
          <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-lg font-medium">{t('partners.states.loadFailed')}</p>
          <p className="text-sm text-gray-500 mt-2">{t('partners.states.retry')}</p>
        </div>
      </div>
    )
  }

  if (!partners || partners.length === 0) {
    return (
      <div className="text-center py-16">
        <h3 className="text-4xl font-medium text-gray-900 mb-2">{t('common.comingSoon.title')}</h3>
        <p className="text-gray-600">{t('common.comingSoon.subtitle')}</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
      {partners.map(partner => (
        <PartnerCard
          key={partner.orgId}
          partner={partner}
          onClick={onPartnerClick}
        />
      ))}
    </div>
  )
}

export default PartnerList 